var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 46,
    viewBox: "0 0 50 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"warning\""
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.9992 27.4635C24.3583 27.4635 23.7437 27.2194 23.2905 26.7848C22.8373 26.3503 22.5827 25.7609 22.5827 25.1464V18.1952C22.5827 17.5807 22.8373 16.9914 23.2905 16.5568C23.7437 16.1223 24.3583 15.8782 24.9992 15.8782C25.6401 15.8782 26.2547 16.1223 26.7079 16.5568C27.161 16.9914 27.4156 17.5807 27.4156 18.1952V25.1464C27.4156 25.7609 27.161 26.3503 26.7079 26.7848C26.2547 27.2194 25.6401 27.4635 24.9992 27.4635ZM21.3745 33.2561C21.3745 32.3343 21.7564 31.4503 22.4361 30.7985C23.1159 30.1467 24.0379 29.7805 24.9992 29.7805C25.9605 29.7805 26.8824 30.1467 27.5622 30.7985C28.2419 31.4503 28.6238 32.3343 28.6238 33.2561C28.6238 34.1779 28.2419 35.0619 27.5622 35.7137C26.8824 36.3655 25.9605 36.7317 24.9992 36.7317C24.0379 36.7317 23.1159 36.3655 22.4361 35.7137C21.7564 35.0619 21.3745 34.1779 21.3745 33.2561Z",
    fill: "#183FEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic-warning",
    d: "M20.7221 2.47636C22.5344 -0.825453 27.464 -0.825453 29.2763 2.47636L49.4367 39.2064C51.1306 42.2927 48.8011 46 45.1596 46H4.83886C1.20212 46 -1.12975 42.2927 0.56176 39.2087L20.7221 2.47636ZM45.162 41.3659L24.9992 4.63354L4.83644 41.3659H45.162Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.4a2f3319512a11a82e7422fa732f59fc.svg";
export { ForwardRef as ReactComponent };